<template>
  <v-app>
    <v-navigation-drawer
      app
      v-model="drawer"
      color="light-blue darken-4"
      style="z-index: 5000"
    >
      <h2
        class="text-h6 pa-4 grey darken-4 white--text font-weight-bold text-center"
      >
        {{ $t("Dashboard") }}
      </h2>
      <LeftNavComponent />
      <template v-slot:append>
        <v-list>
          <v-list-item class="text-center" dense>
            <TawkChatComponent />
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-btn block class="red" dark @click="logout">
              <v-icon small>mdi-logout</v-icon> {{ $t("LogOut") }}
            </v-btn>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar app flat class="full-header" height="80">
      <v-btn
        class="ma-2"
        small
        outlined
        fab
        color="light-blue"
        @click.stop="drawer = !drawer"
      >
        <v-icon small>mdi-menu</v-icon>
      </v-btn>
      <DashboardHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-5">
      <div class="container-ml-0">
        <router-view></router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import DashboardHeaderComponent from "@/components/layout/DashboardHeaderComponent.vue";
import TawkChatComponent from "@/components/layout/TawkChatComponent.vue";
import LeftNavComponent from "@/components/dashboard/LeftNavComponent.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardHeaderComponent,
    LeftNavComponent,
    TawkChatComponent
  },
  data() {
    return {
      drawer: true
    };
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" });
      });
    }
  }
};
</script>

<style></style>
